import './styles.css';
import Logo from '../images/logo.png';
import { Link } from 'react-router-dom';

function HomeHeader() {
  return (
    <div className="header">
        <nav>
            <Link to="/"><img src={Logo} alt="" /></Link>
            <div class="nav-link" id="navLinks">
                <i class="fa fa-times" onclick="hideMenu()"></i>
                <ul>
                    <li><Link to="/">HOME</Link></li>
                    <li><Link to="/about" state={{test: 'test'}}>ABOUT</Link></li>
                    <li><Link to="/course">COURSE</Link></li>
                    {/* <li><Link to="/contact">CONTACT</Link></li> */}
                </ul>
            </div>
            <i class="fa fa-bars" onclick="showMenu()"></i>
        </nav>
        
        <div class="text-box">
            <h1>Bright Eyes University</h1>
            <p>Building Brighter Futures, Transforming Lives through Education at Bright Eyes</p>
            {/* <a href="" class="hero-btn">Visit Us To Know More</a> */}
        </div>
    </div>
  );
}

export default HomeHeader;
